import { useState } from "react";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../Constants";
import * as api from "../../../Services/dashboardService";

export const useDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchKPI = async (params) => {
    setLoading(true);
    try {
      const res = await api.getKPIs(params);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_KPI_FAILED);
      }
    } catch (err) {
      setError(TOAST_MESSAGES.FETCH_KPI_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectCompletion = async (params) => {
    setLoading(true);
    try {
      const res = await api.getProjectCompletion(params);
      if (res.status === 200) {
        return res.data.results;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_COMPLETION_FAILED);
      }
    } catch (err) {
      setError(TOAST_MESSAGES.FETCH_COMPLETION_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillSummary = async (params) => {
    setLoading(true);
    try {
      const res = await api.getBillSummary(params);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillSummaryByProjectId = async (projectId) => {
    setLoading(true);
    try {
      const res = await api.getBillSummaryByProjectId(projectId);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
    } finally {
      setLoading(false);
    }
  };

  const fetchBillSummaryBySiteId = async (siteId) => {
    setLoading(true);
    try {
      const res = await api.getBillSummaryBySiteId(siteId);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_BILL_SUMMARY);
    } finally {
      setLoading(false);
    }
  };

  const fetchApprovals = async (params) => {
    setLoading(true);
    try {
      const res = await api.getApprovals(params);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_APPROVALS_FAILED);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_APPROVALS_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchTaskSummary = async (params) => {
    setLoading(true);
    try {
      const res = await api.getTaskSummary(params);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_APPROVALS_FAILED);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_APPROVALS_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchChecklist = async () => {
    setLoading(true);
    try {
      const res = await api.getCheckList();
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_CHECKLIST_FAILED);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_CHECKLIST_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchAnnouncement = async (params) => {
    setLoading(true);
    try {
      const res = await api.getAnnouncement(params);
      if (res.status === 200) {
        return res?.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_ANNOUNCEMENT_FAILED);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_ANNOUNCEMENT_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const fetchTaskKPI = async (params) => {
    setLoading(true);
    try {
      const res = await api.getTaskKPI(params);
      if (res.status === 200) {
        return res.data;
      } else {
        toast.error(TOAST_MESSAGES.FETCH_TASK_KPI_FAILED);
      }
    } catch (err) {
      toast.error(TOAST_MESSAGES.FETCH_TASK_KPI_FAILED);
    } finally {
      setLoading(false);
    }
  };


  return {
    fetchKPI,
    fetchProjectCompletion,
    fetchBillSummary,
    fetchBillSummaryByProjectId,
    fetchBillSummaryBySiteId,
    fetchApprovals,
    fetchChecklist,
    fetchAnnouncement,
    fetchTaskSummary,
    fetchTaskKPI,
    loading,
    error,
  };
};
